module.exports = __webpack_public_path__ + "media/images/bg_prepaid_inner-9ff2868076fe1c2fa564ba587b6cd344.svg";